export const iconFontAwesomeArrowsArrowUpFromBracket = (
	<i className="fa-solid fa-arrow-up-from-bracket"></i>
);
